import * as React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled, { css } from 'styled-components';
import StarIcon from '@atlaskit/icon/glyph/star';
import StarFilledIcon from '@atlaskit/icon/glyph/star-filled';
import { token } from '@atlaskit/tokens';

interface StarProps {
    label: string;
    className?: string;
    filled?: boolean;
}

export class Star extends React.Component<StarProps> {
    getIcon(label: string, filled: boolean) {
        if (filled) {
            return <StarFilledIcon label={label} size="large" />;
        }
        return <StarIcon label={label} size="large" />;
    }

    render() {
        const { filled, label } = this.props;

        const starIcon = this.getIcon(label, !!filled);

        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        return <StarContainer className={this.props.className}>{starIcon}</StarContainer>;
    }
}

export const EmptyStar: React.FunctionComponent<StarProps> = ({ label, className }) => (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    <Star label={label} className={className} />
);
export const FullStar: React.FunctionComponent<StarProps> = ({ label, className }) => (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    <Star label={label} className={className} filled />
);

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const StarContainer = styled.span`
    ${(props) => {
        // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        return css`
            color: ${token('color.icon.brand', props.theme.color)};
            padding: ${token('space.050', '4px')};
        `;
    }};
`;
